<template>
<div>
<el-select :filterable="true" :remote="true" :remote-method="handleRemote" :value="value" value-key="id" :size="size" :placeholder="$t('card.happening')" v-el-select-loadmore="loadMore" @input="change($event)" :clearable="true" @visible-change="init" @clear="handleRemote">
  <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item" />
  </el-select>
<el-button v-if="config && config.update" @click="handleUpdate" >{{ $t('table.update') }}</el-button>
</div>
</template>

<script>

import {fetchHappeningList} from '../api/happening'
import {debounce} from '../../utils'

export default {
  data () {
    return {
      emptyValue: { user_id: 0 },
      options: [],
      list: [],
      formData: {
        pageIndex: 1,
        pageSize: 10
      }
    }
  },
  created () {
    if (this.value) {
      this.handleRemote(this.value.name)
    } else {
      this.handleUpdate()
    }
  },
  props: ['value', 'placeholder', 'config', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    handleRemote (data) {
      debounce(() => {
        this.dropDownValue = data
        this.options = []
        this.handleUpdate(false)
      }, 2000, true)()
    },
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate (loadMore = false) {
      let q = []
      let query = {}
      // 如果加载更多，页数+1，否则恢复初始值
      if (loadMore) {
        this.formData.pageIndex += 1
        this.list = this.options
        console.log('加载更多')
      } else {
        this.formData.pageIndex = 1
        this.list = []
        console.log('初次加载')
      }
      query.limit = this.formData.pageSize
      query.page = this.formData.pageIndex
      console.log(query)
      if (this.dropDownValue) {
        q.push(['like', 'name', '%' + this.dropDownValue + '%'].join(','))
      }
      let o = []
      o.push('id', 'desc')
      query.q = q.join('&')
      query.o = o.join(',')
      fetchHappeningList(query).then((res) => {
        const _res = res.data.map((item) => { item.id = parseInt(item.id); return item })
        if (_res.length > 0) {
          this.options = [...this.list, ..._res]
        }
      })
    },
    init (open) {
      this.dropDownValue = ''
    },
    loadMore () {
      this.handleUpdate(true)
    }
  },
  watch: {
  },
  directives: {
    'el-select-loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition && this.scrollTop !== 0) {
            binding.value()
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/HappeningSelect.vue